const Paragraph = ({paragraph}) => {
    return (  
        <p>
            {paragraph}
        </p>
    );
}
 
export default Paragraph;